<div class="waec-page-header">
  <img
    class="waec-page-header-image"
    src="/assets/icons/Assets_Certificate_Highlighed.svg"
    alt="Assets_Certificate_Highlighed"
  />
  <h3 class="waec-page-header-text">{{'PROVISIONING.CERTIFICATES.HEADER' | translate}}</h3>
</div>

<div class="page-container" nz-row>
  <nz-card [nzBordered]="false" class="ant-card-body-main">
    <nz-row>
      <section 
        nz-col
        nzXs="24" 
        nzSM="24" 
        nzMd="24" 
        nzLg="24" 
        [nzXl]="isUserCertificate ? 14 : 24" 
        [nzXXl]="isUserCertificate ? 16 : 24"
        class="my-certificates-wrapper"
      >
        <h5>{{'PROVISIONING.CERTIFICATES.SUBHEADER' | translate}}</h5>

        <div class="at-a-glance">
          <nz-select 
            nzAllowClear
            nzPlaceHolder="{{'PROVISIONING.CERTIFICATES.PREVIEW_PLACEHOLDER' | translate}}" 
            [(ngModel)]="certificateID"
            [nzDisabled]="certificateLoading || !isUserVerified"
            [ngClass]="certificateLoading || !isUserVerified ? 'hide-arrow' : 'show-arrow'"
            (ngModelChange)="onSelectCertificate($event)"
            (nzScrollToBottom)="onScrolledToBottom()"
          >
            <nz-option-group [nzLabel]="'PROVISIONING.CERTIFICATES.OWNER' | translate">
              <nz-option 
                *ngFor="let owner of ownerCertificates"
                nzCustomContent 
                [nzValue]="owner?.id"
                [nzLabel]="
                  owner?.candidate?.firstname +' '+
                  owner?.candidate?.surname +' | '+
                  owner?.candidate?.year
                "
              >
                <span>
                  {{ owner?.candidate?.firstname  | titlecase }} 
                  {{ owner?.candidate?.surname  | titlecase }} | 
                  {{ owner?.candidate?.year }}
                </span>
              </nz-option>
            </nz-option-group>

            <nz-option-group nzLabel="{{'PROVISIONING.CERTIFICATES.ACCESSED_ON_CONSENT' | translate}}">
              <nz-option 
                *ngFor="let onConsent of onConsentCertificates"
                nzCustomContent
                [nzValue]="onConsent?.id"
                [nzLabel]="
                  onConsent?.candidate?.firstname +' '+
                  onConsent?.candidate?.surname +' | '+
                  onConsent?.candidate?.year
                "
              >
                <span>
                  {{ onConsent?.candidate?.firstname  | titlecase }} 
                  {{ onConsent?.candidate?.surname  | titlecase }} | 
                  {{ onConsent?.candidate?.year }}
                </span>
              </nz-option>
            </nz-option-group>

            <nz-option-group nzLabel="{{'PROVISIONING.CERTIFICATES.AWAITING_CONSENT' | translate}}">
              <nz-option 
                *ngFor="let awaitingConsent of awaitingConsentCertificates"
                nzCustomContent
                [nzValue]="awaitingConsent?.id"
                [nzLabel]="
                  awaitingConsent?.candidate?.firstname +' '+
                  awaitingConsent?.candidate?.surname +' | '+
                  awaitingConsent?.candidate?.year
                "
              >
                <span>
                  {{ awaitingConsent?.candidate?.firstname  | titlecase }} 
                  {{ awaitingConsent?.candidate?.surname  | titlecase }} | 
                  {{ awaitingConsent?.candidate?.year }}
                </span>
              </nz-option>
            </nz-option-group>
          </nz-select>

          <aside 
            [ngClass]="accessedItems?.length && isUserVerified ? '' : 'not-allowed'" 
            (click)="accessedItems?.length && isUserVerified ? openCertificatesModal() : ''"
          >
            <svg-icon src="assets/icons/view-grid.svg" svgClass="grid-icon"></svg-icon>
            <p>{{'PROVISIONING.CERTIFICATES.AT_A_GLANCE' | translate}}</p>
          </aside>
        </div>

        <nz-result
          nzStatus="info"
          [nzTitle]="'GENERAL.CERTIFICATE_PASSPORT' | translate"
          [nzSubTitle]="certificatePassportDescription"
          *ngIf="showCertificateLayout"
        >
          <ng-template #certificatePassportDescription>
            <br />
            <p>
             {{'PROVISIONING.CERTIFICATES.POOR_QUALITY_PASSPORT_TEXT' | translate}} <span *ngIf="owner"> {{'PROVISIONING.CERTIFICATES.PLEASE_NOTE' | translate}}</span> 
              <span *ngIf="!owner">{{'PROVISIONING.CERTIFICATES.CONTACT_OWNER' | translate}}</span> <br />
              <br />
              <span *ngIf="!accept_result_statement && user.type !== userTypes.VERIFIER && owner"
                >{{'PROVISIONING.CERTIFICATES.CLICK_BUTTON_BELOW' | translate}}
              </span>
            </p>
          </ng-template>

          <div nz-result-extra>
            <button
              nz-button
              (click)="showUploadForm()"
              nzType="primary"
              *ngIf="!accept_result_statement && user.type !== userTypes.VERIFIER && owner && isNigerianCountry"
            >
              {{'GENERAL.CONTINUE' | translate}}
            </button>
            <a
              nz-button
              [routerLink]="pageRoutes.enquiry.openTicket"
              nzType="primary"
              *ngIf="!accept_result_statement && user.type !== userTypes.VERIFIER && owner && !isNigerianCountry"
            >
              {{'GENERAL.CONTINUE' | translate}}
            </a>
          </div>
        </nz-result>

        <div *ngIf="displayCertificateViewer">
          <div class="certificate-wrapper" [ngClass]="!showCertificateLayout ? '' : 'display-none'">
            <div class="empty-state" *ngIf="!hasProvisionedCertificate || invalidCertificateMessage">
              <h5 *ngIf="!invalidCertificateMessage">{{'PROVISIONING.CERTIFICATES.NO_CERTIFICATE' | translate}}</h5>
              <p>
                <span *ngIf="!invalidCertificateMessage">
                  <!-- To preview your certificate you need to Verify
                  your Identity first. -->

                  {{'PROVISIONING.CERTIFICATES.ACCESS_PROMPT' | translate}}
                </span>

                <span *ngIf="invalidCertificateMessage">{{ invalidCertificateMessage }}</span>
              </p>

              <button 
                nz-button 
                nzSize="large" 
                nzType="primary" 
                (click)="goToCertificateAccess()"
                *ngIf="!invalidCertificateMessage"
              >
                {{'GENERAL.ACCESS_CERTIFICATE' | translate}}
                <svg-icon src="assets/icons/arrow-narrow-right-white.svg"></svg-icon>
              </button>

              <button 
                nz-button 
                nzSize="large" 
                nzType="primary" 
                (click)="openOtpModal()"
                *ngIf="invalidCertificateMessage && showRequestConsent"
              >
                {{'PROVISIONING.CERTIFICATES.REQUEST_CONSENT' | translate}}
                <svg-icon src="assets/icons/arrow-narrow-right-white.svg"></svg-icon>
              </button>

              <!-- <button 
                nz-button 
                nzSize="large" 
                nzType="primary" 
                (click)="onVerifyIdentity()"
                *ngIf="invalidCertificateMessage && !isUserVerified"
              >
                Verify Identity
                <svg-icon src="assets/icons/arrow-narrow-right-white.svg"></svg-icon>
              </button> -->
            </div>

            <div 
              class="empty-state" 
              *ngIf="
                hasProvisionedCertificate &&
                !isUserVerified
              "
            >
              <h5>{{'GENERAL.UNVERIFIED_IDENTITY' | translate}}</h5>
              <p>
                {{'PROVISIONING.CERTIFICATES.UNVERIFIED_DESC' | translate}}
              </p>
              <button 
                nz-button 
                nzSize="large" 
                nzType="primary" 
                (click)="onVerifyIdentity()"
              >
                {{'PROVISIONING.CERTIFICATES.VERIFY_IDENTITY' | translate}}
                <svg-icon src="assets/icons/arrow-narrow-right-white.svg"></svg-icon>
              </button>
            </div>

            <div 
              class="empty-state2" 
              *ngIf="
                isUserVerified &&
                !certificateImages?.length &&
                !certificateLoading &&
                !invalidCertificateMessage
              "
            >
              <p>
                <span>{{'PROVISIONING.CERTIFICATES.NO_CURRENT_CERT' | translate}}</span>
              </p>
            </div>

            <digicert-load-spinner 
              class="load-spinner"
              [ngClass]="certificateLoading ? 'show-spinner': 'hide-spinner'"
            ></digicert-load-spinner>

            <angular-image-viewer
              [src]="certificateImages"
              [config]="config"
              (customImageEvent)="handleCertificateEvent($event)"
            ></angular-image-viewer>
          </div>
        </div>
      </section>
  
      <section 
        nz-col 
        nzXs="24" 
        nzSM="24" 
        nzMd="24" 
        nzLg="24" 
        nzXl="10"
        nzXXl="8"
        class="certificate-activity-wrapper"
        *ngIf="isUserCertificate"
      >
        <h5>
          <span>{{'PROVISIONING.CERTIFICATES.CERTIFICATE_ACTIVITY' | translate}}</span>
          <svg-icon src="assets/icons/info-icon.svg"></svg-icon>
        </h5>

        <div class="info-card" *ngIf="isUserCertificate">
          <p 
            *ngIf="!hasShareHistory && !selectedCertificateDetails" 
            class="info-empty-state"
          >
            <span> {{'PROVISIONING.CERTIFICATES.NO_CERT_SHARE_HISTORY' | translate}}</span>
          </p>

          <div class="certificate-activity"  *ngIf="selectedCertificateDetails">
            <section>
              <svg-icon src="assets/lock-open.svg"></svg-icon>
              <p>{{ selectedCertificateDetails?.third_party_access_count || 0 }} {{'PROVISIONING.CERTIFICATES.CERT_ACCESS_COUNT' | translate}} </p>
            </section>
  
            <section>
              <svg-icon src="assets/share.svg"></svg-icon>
              <p>
                {{'PROVISIONING.CERTIFICATES.SHARED_INSTITUTION_COUNT' | translate}} 
                {{ selectedCertificateDetails?.institutions_access?.length || 0 }} {{'PROVISIONING.CERTIFICATES.INSTITUTION(S)' | translate}}
              </p>
            </section>
          </div>
        </div>

        <div class="info-card">
          <p 
            *ngIf="!isCertificateSelected && !selectedCertificateDetails" 
            class="info-empty-state"
          >
            {{'PROVISIONING.CERTIFICATES.NO_INFO' | translate}}
          </p>

          <div class="certificate-detail-wrapper" *ngIf="selectedCertificateDetails">
            <section nz-row>
              <div 
                nz-col 
                nzXs="24" 
                nzSm="24" 
                nzMd="12" 
                nzLg="12" 
                nzXl="14"
                class="certificate-detail"
              >
                <h6>{{'PROVISIONING.CERTIFICATES.CANDIDATE_NAME' | translate}}</h6>
                <h4>
                  {{ selectedCertificateDetails?.candidate?.firstname }} 
                  {{ selectedCertificateDetails?.candidate?.surname }}
                </h4>
              </div>
              
              <div 
                nz-col 
                nzXs="24" 
                nzSm="24" 
                nzMd="12" 
                nzLg="12" 
                nzXl="8"
                class="certificate-detail"
              >
                <h6>{{'GENERAL.EXAM_COUNTRY' | translate}}</h6>
                <h4>
                  <img
                    class="selected-country"
                    alt="{{userCountry?.country_code}}"
                    [src]="externalImageLinks.FLAGS + userCountry?.country_code + '.svg'"
                    height="20"
                    width="20"
                  />
                  &nbsp;&nbsp;{{ userCountry?.name | uppercase }}
                </h4>
              </div>
            </section>

            <section nz-row>
              <div 
                nz-col 
                nzXs="24" 
                nzSm="24" 
                nzMd="12" 
                nzLg="12" 
                nzXl="14"
                class="certificate-detail"
              >
                <h6>{{'GENERAL.EXAM_YEAR' | translate}}</h6>
                <h4>{{ selectedCertificateDetails?.candidate?.year }} </h4>
              </div>
  
              <div 
                nz-col 
                nzXs="24" 
                nzSm="24" 
                nzMd="12" 
                nzLg="12" 
                nzXl="8"
                class="certificate-detail"
              >
                <h6>{{'GENERAL.EXAM_NUMBER' | translate}}</h6>
                <h4>{{ selectedCertificateDetails?.candidate?.candidate_number }}</h4>
              </div>
            </section>
          </div>
        </div>

        <!-- <div class="info-card advert">
          <h5>You can also view the certificate <br class="text-breaker"> on the Mobile App</h5>
          <blockquote>
            “The WAEC Digital; Indeed a revolutionary platform that has helped individuals” 
            <span>Ahmed</span>
          </blockquote>

          <div class="app-store">
            <img src="assets/Google Play.png" alt="" />
            <img src="assets/Apple Store.png" alt="" />
          </div>
        </div> -->
      </section>
    </nz-row>
  </nz-card>
</div>



<!-- User Information -->
<app-user-verification
  *ngIf="userInformationVerification"
  (successResponse)="userVerificationAfterSuccessViewCertificate()"
  (closeModal)="cancelMeansofIdentificationModal()"
  [step]="userInformationWindowStep"
  [year]="Year"
  [actions]="processStepsModalKeys.VIEW_CERTIFICATE"
></app-user-verification>

<!-- Certificates Modal -->
<digicert-certificates-modal
  *ngIf="showCertificatesModal"
  [lastPage]="lastPage"
  [parentTotal]="total"
  [parentTo]="to"
  [parentCurrentPage]="pageNumber"
  [accessedCertificates]="accessedItems"
  (closeModal)="closeCertificatesModal($event)"
>
</digicert-certificates-modal>

<!-- Passport State Modal -->
<nz-modal
  [(nzVisible)]="pictureStateWindow"
  [nzFooter]="modalFooter"
  [nzContent]="modalContent"
  [nzMask]="true"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleUploadModalCancel()"
>
  <ng-template #modalContent>

    <div nz-row>
      <div>
        <h2>{{'PROVISIONING.CERTIFICATES.UPLOAD_DOCUMENTS' | translate | uppercase}}</h2>
        <p *ngIf="provisionObject == null || provisionObject == provisionedObjects.DOCUMENTS_REQUESTED">
          {{'PROVISIONING.CERTIFICATES.UPLOAD_DESC' | translate}}
        </p>
      </div>
    </div>
    <div
      class="row"
      *ngIf="
        provisionObject == provisionedObjects.DOCS_SUBMITTED_AWAITING_SOR || provisionObject == provisionedObjects.DOCUMENTS_IN_REVIEW || provisionObject == provisionedObjects.SOR_SUBMITTED
      "
    >
      <nz-alert
        nzType="default"
        nzMessage="{{'PROVISIONING.CERTIFICATES.DOCUMENTS_SUBMITTED' | translate}}"
        nzDescription="{{'PROVISIONING.CERTIFICATES.UPLOAD_PENDING' | translate}}"
        nzShowIcon
      ></nz-alert>
    </div>
    <form
      nz-form
      [formGroup]="requestDocumentForm"
      *ngIf="provisionObject == null || provisionObject == provisionedObjects.DOCUMENTS_REQUESTED"
    >
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="passport"
          >{{'PROVISIONING.CERTIFICATES.RECENT_PASSPORT' | translate | titlecase}}</nz-form-label
        >
        <nz-form-control [nzSpan]="24">
          <nz-upload
            [(nzFileList)]="passportList"
            [nzLimit]="1"
            [nzMultiple]="false"
            [nzSize]="1500"
            id="passport"
            [nzBeforeUpload]="prePassportUpload"
            [nzDisabled]="passportList.length > 0"          
          >
            <button nz-button class="select-passport-btn">
              <span nz-icon [nzType]="analyzingImage ? 'loading' : 'upload'"></span>
              {{analyzingImage ? ("ENQUIRY.TICKET-INFORMATION.ANALYZING_IMAGE" | translate) : "PROVISIONING.CERTIFICATES.SELECT_PASSPORT" | translate}}          
            </button>
          </nz-upload>
          
        </nz-form-control>
        
        <br>
        <div nz-row> 
          <div *ngIf="passportList.length == 0 && !validImage" nz-col [nzSpan]="24" class="invalid-image-wrapper">
            <img class="invalid-image" [src]="imageDataUrl" alt="">
            <p *ngIf="!validImage && imageDataUrl" class="red" >{{'PROVISIONING.CERTIFICATES.INVALID_IMAGE' | translate}}</p>
          </div>
  
          <div *ngIf="passportList.length > 0" nz-col [nzSpan]="24" class="invalid-image-wrapper">
            <p><img [src]="imageDataUrl" alt="" class="valid-image"></p>
          </div>
        </div>
  
        <small
          >{{'PROVISIONING.CERTIFICATES.UPLOAD_PASSPORT_HINT' | translate}}
        </small>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="passport"
          >{{'PROVISIONING.CERTIFICATES.BIRTH_CERTIFICATE' | translate}}</nz-form-label
        >
        <nz-form-control [nzSpan]="24">
          <nz-upload
            [(nzFileList)]="dateofBirthList"
            [nzLimit]="1"
            [nzMultiple]="false"
            [nzSize]="2000"
            id="passport"
            [nzBeforeUpload]="preBirthDocumentUpload"
            [nzDisabled]="dateofBirthList.length > 0"
          >
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              {{'ENQUIRY.TICKET-INFORMATION.SELECT_DOCUMENT' | translate}}
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="radio"
          >{{'PROVISIONING.CERTIFICATES.SCANNED_PROMPT' | translate}}</nz-form-label
        >
        <nz-radio-group
          name="radio"
          id="radio"
          (ngModelChange)="onIsScannedCopyAvailable($event)"
          formControlName="haveScannedCertificate"
        >
          <label nz-radio nzValue="yes">{{'GENERAL.YES' | translate}}</label>
          <label nz-radio nzValue="no">{{'GENERAL.NO' | translate}}</label>
        </nz-radio-group>
      </nz-form-item>
  
      <nz-form-item *ngIf="scannedCertificateShow">
        <nz-form-label [nzSpan]="24" nzFor="certificate"
          >{{'PROVISIONING.CERTIFICATES.SCANNED_CERT' | translate}}</nz-form-label
        >
        <nz-form-control [nzSpan]="24">
          <nz-upload
            [(nzFileList)]="documentList"
            [nzBeforeUpload]="preDocumentUpload"
            [nzDisabled]="documentList.length > 0"
            id="certificate"
          >
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              {{'PROVISIONING.CERTIFICATES.SELECT_CERTIFICATE' | translate}}
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="scannedStatementofResult">
        <nz-form-label [nzSpan]="24" nzFor="result"
          >{{'PROVISIONING.CERTIFICATES.STATEMENT_OF_RESULT' | translate}}</nz-form-label
        >
        <nz-form-control [nzSpan]="24">
          <nz-upload
            [(nzFileList)]="resultList"
            [nzLimit]="1"
            [nzMultiple]="false"
            [nzSize]="2000"
            [nzBeforeUpload]="preResultUpload"
            id="result"
          >
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              {{'ENQUIRY.TICKET-INFORMATION.SELECT_DOCUMENT' | translate}}
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>

    </form>
  </ng-template>

  <ng-template #modalFooter>
    <div nz-col>
      <div>
        <button
          nz-button
          [nzLoading]="loading"
          *ngIf="provisionObject == null || provisionObject == provisionedObjects.DOCUMENTS_REQUESTED"
          (click)="submitDocuments()"
          [nzType]="'primary'"
        >
          {{'GENERAL.SUBMIT' | translate}}
        </button>

        <button nz-button nzType="default" (click)="handleUploadModalCancel()">
          <span>{{'GENERAL.CANCEL' | translate}}</span>
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>

<!-- Statement of Result Upload Modal -->
<nz-modal
  [(nzVisible)]="resultStateWindow"
  [nzFooter]="modalFooterStatementofResult"
  [nzContent]="uploadModalContent"
  [nzMask]="true"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleUploadModalCancel()"
>

  <ng-template #uploadModalContent>

    <div nz-row>
      <div>
        <h2>{{'PROVISIONING.CERTIFICATES.UPLOAD_DOCUMENT' | translate}}</h2>
        <p *ngIf="provisionObject == provisionedObjects.DOCS_SUBMITTED_AWAITING_SOR">
          {{'PROVISIONING.CERTIFICATES.PROVIDE_STATEMENT_OF_RESULT' | translate}}
        </p>
      </div>
    </div>
  
    <div class="row" *ngIf="provisionObject == provisionedObjects.SOR_SUBMITTED || provisionObject == provisionedObjects.DOCUMENTS_IN_REVIEW">
      <nz-alert
        nzType="default"
        [nzMessage]="'PROVISIONING.CERTIFICATES.DOCUMENTS_SUBMITTED' | translate"
        [nzDescription]="'PROVISIONING.CERTIFICATES.UPLOAD_PENDING' | translate"
        nzShowIcon
      ></nz-alert>
    </div>
    
    <form
      nz-form
      [formGroup]="requestDocumentForm"
      *ngIf="provisionObject == provisionedObjects.DOCS_SUBMITTED_AWAITING_SOR"
    >
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="result"
          >{{'PROVISIONING.CERTIFICATES.STATEMENT_OF_RESULT' | translate}}</nz-form-label
        >
        <nz-form-control [nzSpan]="24">
          <nz-upload
            [(nzFileList)]="resultList"
            [nzLimit]="1"
            [nzMultiple]="false"
            [nzSize]="2000"
            [nzBeforeUpload]="preResultUpload"
            id="result"
          >
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              {{'ENQUIRY.TICKET-INFORMATION.SELECT_DOCUMENT' | translate}}
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-template>

  <ng-template #modalFooterStatementofResult>
    <div nz-col>
      <div>
        <button
          nz-button
          [nzLoading]="loading"
          *ngIf="provisionObject == provisionedObjects.DOCS_SUBMITTED_AWAITING_SOR"
          (click)="submitStatementResult()"
          [nzType]="'primary'"
        >
          {{'GENERAL.SUBMIT' | translate }}
        </button>

        <button nz-button nzType="default" (click)="handleModalCancel()">
          <span>{{'GENERAL.CANCEL' | translate}}</span>
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>

<!-- OTP Modal  -->
<nz-modal
  [nzMask]="true"
  nzMaskClosable="false"
  [(nzVisible)]="otpModal"
  [nzTitle]="modalotpTitle"
  [nzContent]="modalotpContent"
  [nzFooter]="null"
  (nzOnCancel)="cancelOtpModal()"
  nzCentered="true"
>
  <ng-template #modalotpTitle>
    {{ accessFormData ? ('PROVISIONING.PROVISION.NOTIFICATION' | translate) : ('PROVISIONING.PROVISION.OOPS' | translate) }}
  </ng-template>

  <ng-template #modalotpContent>
    <p>
      {{ message }}
    </p>
    <form nz-form [formGroup]="otpFormGroup" (submit)="submitOtp()">
      <nz-form-item *ngIf="accessFormData">
        <nz-col nzSpan="24">
          <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16">
            <nz-form-label nzFor="otp">{{'GENERAL.ENTER_CODE' | translate}}</nz-form-label>
          </nz-col>
          <nz-col nzSpan="24">
            <nz-form-control [nzErrorTip]="'PROVISIONING.PROVISION.OTP_TEXT' | translate">
              <input
                nz-input
                name="otp"
                id="otp"
                formControlName="otp"
                nzPlaceHolder="{{'GENERAL.ENTER_CODE' | translate}}"
              />
            </nz-form-control>
          </nz-col>
        </nz-col>
      </nz-form-item>
      <nz-form-item *ngIf="!accessFormData">
        <nz-col nzSpan="24">
          <button
            nz-button
            nzType="primary"
            [disabled]="loading"
            [nzLoading]="loading"
            (click)="showNotify()"
          >
            {{'PROVISIONING.CERTIFICATES.REQUEST_CONSENT' | translate | uppercase}}
          </button>
        </nz-col>
        <br />
        <br />
        <nz-col nzSpan="24">
          <p>
            <a
              routerLink="{{pageRoutes.enquiry.openTicket}}/{{ ticketCategory }}"
              class="log_ticket"
              >{{'PROVISIONING.PROVISION.LODGE_COMPLAINT' | translate}}</a
            >
          </p>
        </nz-col>
      </nz-form-item>
      <nz-form-item
        class="mt-2 mb-2"
        *ngIf="accessFormData"
      >
        <nz-col nzSpan="24">
          <nz-form-control>
            <button nz-button nzType="secondary" (click)="cancelOtpModal()">
              {{'GENERAL.CANCEL' | translate | uppercase}}
            </button>
            <button
              nz-button
              nzType="primary"
              [disabled]="loading"
              [nzLoading]="loading"
            >
              {{'GENERAL.VERIFY' | translate | uppercase}}
            </button>
          </nz-form-control>
        </nz-col>
      </nz-form-item>
      <nz-form-item
      class="mb-2 mt-2"
        *ngIf="accessFormData?.codeExpiryTime"
      >
        <n-col nzSpan="24">
          <p class="text-xs ion-text-center mt-4">
            <i>{{'PROVISIONING.PROVISION.CODE_EXPIRY' | translate}} {{ accessFormData?.codeExpiryTime }}</i>
          </p>
        </n-col>
      </nz-form-item>
    </form>
  </ng-template>
</nz-modal>


<!-- Survey Modal -->
<!-- <nz-modal
  [nzStyle]="{ top: '20px' }"
  [nzMask]="true"
  nzMaskClosable="false"
  nzWidth="900px"
  nzClosable="true"
  [(nzVisible)]="customerSurveyModal"
  nzTitle="{{'SHARED.SUPPORT_MODAL.CUSTOMER_SURVEY' | translate}}"
  [nzContent]="modalSurvey"
  (nzOnCancel)="cancelSurveyModal()"
>
  <ng-template #modalSurvey>
    <iframe [src]="surveyUrl" id="surveyFrame" width="100%" height="700"></iframe>
  </ng-template>
  <div *nzModalFooter></div>
</nz-modal>

-->

<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>
